// Images
import { AmericanExpress, ApplePay, DinersClub, Discover, GooglePay, JCB, Mastercard, UnionPay, Visa } from "../assets/images/svg";

/**
    * @function getBrandLogo
    * @params brand
    * @description used to get brand logo
*/
export const getBrandLogo = (brand) => {
    switch (brand) {
        case "visa":
            return <Visa />;
        case "mastercard":
            return <Mastercard />;
        case "american_express":
            return <AmericanExpress />;
        case "discover":
            return <Discover />;
        case "jcb":
            return <JCB />;
        case "diners_club":
            return <DinersClub />;
        case "unionpay":
            return <UnionPay />;
        case "apple_pay":
            return <ApplePay />;
        case "google_pay":
            return <GooglePay />;
        default:
            return <Visa />;
    }
};

/**
    * @function lazyRetry
    * @params componentImport
    * @description used to retry loading a chunk to avoid chunk load error for out of date code
*/
export const lazyRetry = (componentImport) => {
    return new Promise((resolve, reject) => {
        // check if the window has already been refreshed
        const hasRefreshed = JSON.parse(
            window.sessionStorage.getItem('retry-lazy-refreshed') || 'false'
        );
        // try to import the component
        componentImport().then((component) => {
            window.sessionStorage.setItem('retry-lazy-refreshed', 'false'); // success so reset the refresh
            resolve(component);
        }).catch((error) => {
            if (!hasRefreshed) { // not been refreshed yet
                window.sessionStorage.setItem('retry-lazy-refreshed', 'true'); // we are now going to refresh
                return window.location.reload(); // refresh the page
            }
            reject(error); // Default error behaviour as already tried refresh
        });
    });
}